define('fukit/view/block/content.management.title.and.actions.view',['require','exports','module','underscore','../../behavior/base.unsaved.changes.behavior','../../behavior/bind.and.format.option.values.behavior','../../behavior/bind.component.model.to.container.model.behavior','../../behavior/confirm.model.destroy.on.event.behavior','./grid.container.view','../../behavior/invoke.method.on.event.behavior','../../behavior/invoke.model.method.on.event.behavior','redactor/redactor','uikit/uikit'],function(require, exports, module) {
  //prettier-ignore
  var _                                          = require('underscore'),
      BaseUnsavedChangesBehavior                 = require('../../behavior/base.unsaved.changes.behavior'),
      BindAndFormatOptionValuesBehavior          = require('../../behavior/bind.and.format.option.values.behavior'),
      BindComponentModelToContainerModelBehavior = require('../../behavior/bind.component.model.to.container.model.behavior'),
      ConfirmModelDestroyOnEventBehavior         = require('../../behavior/confirm.model.destroy.on.event.behavior'),
      GridContainerView                          = require('./grid.container.view'),
      InvokeMethodOnEventBehavior                = require('../../behavior/invoke.method.on.event.behavior'),
      InvokeModelMethodOnEventBehavior           = require('../../behavior/invoke.model.method.on.event.behavior'),
      Redactor                                   = require('redactor/redactor'),
      UIKit                                      = require('uikit/uikit');

  var BindAndFormatOptionValuesWithUnsavedChangesBehavior = BindAndFormatOptionValuesBehavior.extend({
    behaviors: function() {
      var self = this;
      return {
        BaseUnsavedChangesBehavior: {
          behaviorClass: BaseUnsavedChangesBehavior.extend({
            initialize: function() {
              BaseUnsavedChangesBehavior.prototype.initialize.apply(this, arguments);
              _.extend(self, this);
            },
          }),
        },
      };
    },

    formatAndSetOptionFromModelAttribute: function(option, resource, attribute, formatter) {
      var self = this;
      var debouncedFormatAndSetOptionValue = _.debounce(function() {
        var value = attribute ? (resource ? resource.get(attribute) : null) : resource;

        if (_.isFunction(formatter)) {
          self.view[option] = formatter.call(self, value);
        } else {
          this.view[option] = value;
        }
      });

      debouncedFormatAndSetOptionValue();
    },
  });

  var TitleView = UIKit.ItemView.extend({
    template: function() {
      return '<ui name="redactorView"/>';
    },

    internalViewBindings: {
      redactorView: {
        model: 'model',
      },
    },

    internalViewOptions: {
      redactorView: function() {
        return {
          type: Redactor.RedactorView,
          className: 'redactor focus',
          focus: true,
          limiter: 150,
          horizontallyScrollable: true,
          headerTag: 'h4',
          model: this.model,
          placeholder: this.getOption('titlePlaceholder'),
          bindings: {
            value: this.getOption('titleModelAttribute'),
          },
          behaviors: {
            InvokeMethodOnEventBehavior: {
              eventName: 'first:render change:model',
              method: function() {
                if (this.view.model) {
                  this.view.disabled = false;
                } else {
                  this.view.disabled = true;
                }
              },
              behaviorClass: InvokeMethodOnEventBehavior,
            },
          },
        };
      },
    },
  });

  var DeleteActionView = UIKit.Button.extend({
    options: _.extend({}, UIKit.Button.prototype.options, {
      icon: 'trash',
      circular: true,
    }),

    attributes: {
      style: 'margin-right: 0.5em;',
    },

    behaviors: function() {
      return {
        BindAndFormatOptionValuesBehavior: {
          optionValues: {
            disabled: {
              resource: this.getOption('state'),
              eventName: 'change:selectedModel selectedModel:sync',
              formatter: function(state) {
                var selectedModel = state.get('selectedModel');
                return !selectedModel || selectedModel.isNew();
              },
            },
          },
          behaviorClass: BindAndFormatOptionValuesBehavior,
        },
        ConfirmModelDestroyOnPressBehavior: {
          eventName: 'press',
          behaviorClass: ConfirmModelDestroyOnEventBehavior,
        },
      };
    },
  });

  var SaveActionView = UIKit.Button.extend({
    options: {
      color: 'primary',
      icon: 'save',
      circular: true,
      disabled: true,
    },

    attributes: {
      style: 'margin-right: 0.5em;',
    },

    behaviors: function() {
      var self = this;

      return {
        InvokeModelMethodOnEventBehavior: {
          method: 'save',
          behaviorClass: InvokeModelMethodOnEventBehavior,
        },
        BindAndFormatOptionValuesWithUnsavedChangesBehavior: {
          optionValues: {
            disabled: {
              formatWithoutResource: true,
              formatter: function(model) {
                var isEmptyField = function(fieldValue) {
                  if (!_.isString(fieldValue)) {
                    return true;
                  } else {
                    //prettier-ignore
                    var tags = /<[^>]+>/g,
                        spaces = /&nbsp;|\s/g;
                    return fieldValue.replace(spaces, '').replace(tags, '').length == 0;
                  }
                };
                return !this.unsavedChangesExist() || isEmptyField(model.get(self.getModelAttributeFromMap('title')));
              },
            },
          },
          behaviorClass: BindAndFormatOptionValuesWithUnsavedChangesBehavior,
        },
      };
    },

    getModelAttributeFromMap: function(attribute) {
      return this.getOption('attributeMap')[attribute] || '';
    },
  });

  var ActionsView = UIKit.ComponentsContainerView.extend({
    className: UIKit.ComponentsContainerView.prototype.className + ' note actions container',

    components: function() {
      return [
        {
          name: 'contentManagementDeleteActionView',
          type: DeleteActionView,
          state: this.getOption('state'),
        },
        {
          name: 'contentManagementSaveActionView',
          type: SaveActionView,
          attributeMap: this.getOption('attributeMap'),
          state: this.getOption('state'),
        },
      ];
    },
  });

  var ContentManagementTitleAndActionsView = GridContainerView.extend({
    className: GridContainerView.prototype.className + ' middle aligned',

    components: function() {
      return [
        {
          size: 12,
          content: {
            type: TitleView,
            state: this.getOption('state'),
            model: this.getOption('state')
              ? this.getOption('state').get(this.getOption('selectedModelAttribute'))
              : null,
            titleModelAttribute: this.getModelAttributeFromMap('title'),
            titlePlaceholder: this.getOption('titlePlaceholder'),
            behaviors: {
              BindAndFormatOptionValuesBehavior: {
                optionValues: {
                  model: {
                    resource: this.getOption('state'),
                    attribute: this.getOption('selectedItemAttribute'),
                  },
                },
                behaviorClass: BindAndFormatOptionValuesBehavior,
              },
            },
          },
        },
        {
          aligned: 'right',
          size: 4,
          content: {
            type: ActionsView,
            state: this.getOption('state'),
            model: this.getOption('state')
              ? this.getOption('state').get(this.getOption('selectedModelAttribute'))
              : null,
            attributeMap: this.getOption('attributeMap'),
            behaviors: {
              BindAndFormatOptionValuesBehavior: {
                optionValues: {
                  model: {
                    resource: this.getOption('state'),
                    attribute: this.getOption('selectedItemAttribute'),
                  },
                },
                behaviorClass: BindAndFormatOptionValuesBehavior,
              },
              BindComponentModelToContainerModelBehavior: {
                behaviorClass: BindComponentModelToContainerModelBehavior,
              },
            },
          },
        },
      ];
    },

    getModelAttributeFromMap: function(attribute) {
      var attributeMap = this.getOption('attributeMap');
      if (!attributeMap) {
        return '';
      } else {
        return attributeMap[attribute] || '';
      }
    },
  });

  module.exports = ContentManagementTitleAndActionsView;
});

